import React from 'react';
import { VStack, View } from 'native-base';
import { ImageBackground, SafeAreaView } from 'react-native';
import { Asset } from 'expo-asset';


type WrapperProps = {
  children: React.ReactNode;
};

export const Wrapper = ({ children }: WrapperProps) => {
  return (
    <SafeAreaView style={{ flex: 1 }}>
      <VStack w="full" h="full" bg="#ffba00">
        <ImageBackground
          resizeMode="repeat"
          style={{ height: '100%' }}
          source={{
            uri: Asset.fromModule(require('assets/pattern.png')).uri,
          }}
        >
          <View flex={1} mt='60px'>{children}</View>
        </ImageBackground>
      </VStack>
    </SafeAreaView>
  );
};
